<template>
  <div class="mt30">
    <div class="account-subtitle" v-html="texts.select_plan" />
    <DeployerUiPlans
      v-if="whiteLabelStore.config?.paid_plans"
      :whitelabel-plans="whiteLabelStore.config?.paid_plans"
    />

    <template v-if="false">
      <div class="account-subtitle mt30" v-html="texts.additional_feeds" />
      <p class="account-subtext" v-html="texts.additional_feeds_text" />

      <DeployerUiFormInputText
        v-model="additionalFeeds"
        :placeholder="
          texts.additional_feeds_placeholder.replace('[num]', maxFeeds)
        "
        class="additional-feeds"
      />

      <div class="total">
        <div class="price">
          <span class="opacity-40 fw500">Total</span>&nbsp;
          <span class="opacity-60 fw700">$ {{ formatPrice(totalPrice) }}</span
          >&nbsp;
          <span class="opacity-40 fw500">/month</span>
        </div>
        <p class="total-text" v-html="texts.plan_cancel_notice" />
      </div>
    </template>
    <button
      v-if="
        accountStore.account?.plan?.plan_id &&
        Number(deployerStore.selectedPlan?.id) !==
          accountStore.account?.plan?.plan_id
      "
      type="button"
      class="btn grey-border mt20"
      @click.prevent="updatePlan"
      v-html="
        accountStore.account?.plan?.plan_id
          ? texts.update_plan
          : 'Select and pay plan'
      "
    />
    <button
      v-else-if="!accountStore.account?.plan?.plan_id"
      type="button"
      class="btn grey-border mt20"
      @click.prevent="updatePlan"
    >
      Select and pay plan
    </button>
  </div>
</template>

<script setup>
const additionalFeeds = ref('')

const textsStore = useTextsStore()
const whiteLabelStore = useWhitelabelStore()
const deployerStore = useDeployerStore()
const accountStore = useAccountStore()
const newWalletStore = useNewWalletStore()
const texts = computed(() => textsStore.account.plan.box_manage)

//TODO: Kamil count right value
const totalPrice = computed(() => {
  return 1950
})

//TODO: Kamil change to right value for max additional feeds (displayed in field placeholder)
const maxFeeds = computed(() => {
  return 5
})

//TODO: Kamil - add functionality
const updatePlan = () => {
  payDeployment()
}

function payDeployment() {
  if (!deployerStore.selectedPlan.paymentUrl)
    console.error('Payment URL not provided in cms')

  const url = `${deployerStore.selectedPlan.paymentUrl}?refId=${newWalletStore.account.address}`

  navigateTo(url, {
    external: true,
    open: {
      target: '_blank'
    }
  })
}
</script>

<style lang="scss" scoped>
.additional-feeds {
  width: 100%;
  max-width: 240px;
}

.total {
  border-radius: 10px;
  background: var(--Banner-5, rgba(0, 0, 0, 0.05));
  padding: 25px 20px;
  margin-block: 30px;

  .price {
    font-size: 1.8rem;
    margin-bottom: 15px;
  }

  .total-text {
    margin-block: 0;
    font-size: 1.2rem;
    opacity: 0.7;
  }
}
</style>
